import './common';
import {post} from '../inc/js/ajax';
import {showMessages, Popup} from '../inc/js/dom_utils';
import {getEnv} from '../inc/js/utils';

// Debug
if(getEnv() === 'dev') {
    // Peu importe si on divulgue ces informations en prod, ce ne sont pas de vrais logins
    document.getElementById('login-right').insertAdjacentHTML('beforeend', `
	<div class="mt-3" style="cursor: pointer;">
	    <div class="tmp-login" data-email="admin@vitroto.fr" data-pwd="FNvNIGG3/kZSS9lVld/l">Compte admin</div>
	    <div class="tmp-login" data-email="michael.robertson@free.fr" data-pwd="FNvNIGG3/kZSS9lVld/l">Compte responsable</div>
	    <div class="tmp-login" data-email="micriprob@gmail.com" data-pwd="FNvNIGG3/kZSS9lVld/l">Compte agence</div>
	</div>
    `);

    document.querySelectorAll('.tmp-login')?.forEach(el => {
	el.addEventListener('click', e => {
	    document.getElementById('email').value = el.dataset.email;
	    document.getElementById('pwd').value = el.dataset.pwd;
	    document.querySelector('#main-form button[type="submit"]').click();
	});
    });
}

// LOGIN
document.getElementById('main-form').addEventListener('submit', async function(e) {
    e.preventDefault();
    const formData = new FormData(this);
    formData.append('a', 'login');
    await post(formData, {
	auth: false,
	err_msg: {'': "Vos informations n'ont pas été reconnues"}
    });
    //this.remove();
    //history.replaceState({success: true}, 'title', '/success.html')
    window.location.reload();	// Attente validation par admin
});

// MOT DE PASSE OUBLIÉ
document.getElementById('forgot-pwd').addEventListener('click', function(e) {
    const popup = getPopup();
    document.getElementById('fp-email').value = document.getElementById('email').value;
    document.getElementById('fp-pwd').value = '';
    document.getElementById('form-forgot-pwd').classList.remove('was-validated');
    popup.show();
});

// HELPERS
function getPopup() {
    if(getPopup.popup === null) {
	const body = `
	<form id="form-forgot-pwd" class="needs-validation" novalidate>
	    <div class="mb-3">
		<label for="fp-email">Identifiant</label>
		<input type="email" name="email" id="fp-email" class="form-control" autocomplete="username" required>
		<div class="invalid-feedback">Veuillez indiquer votre email</div>
	    </div>
	    <div class="mb-3">
		<label for="fp-pwd">Nouveau mot de passe (*)</label>
		<input type="password" name="new_pwd" id="fp-pwd" class="form-control" autocomplete="new-password" minlength="6" required
		pattern="(?=.*[a-z])(?=.*[A-Z]).*">
		<div class="invalid-feedback">Veuillez indiquer votre mot de passe (minimum 6 caractères dont minuscule - majuscule)</div>
	    </div>
	    <small>(*) Ce nouveau mot de passe sera activé lorsque vous aurez cliqué dans l'email que vous allez recevoir.<br><br>
	    Cette email est valable 24h.<small>
	</form>`;
	const popup = getPopup.popup = Popup.get('popup-forgot-pwd', {
	    btn_x: true,
	    backdrop: 'static',
	    html_header: '<h1 class="h2">Mot de passe oublié</h1>',
	    html_body: body,
	    html_footer: '<button type="submit" form="form-forgot-pwd" class="btn btn-primary">Soumettre</button>'
	});

	popup.setEvents([
	    {selector: '#form-forgot-pwd', type: 'submit', listener: async function(e) {
		e.preventDefault();
		const form_data = new FormData(this);
		form_data.append('a', 'forgot_pwd');
		await post(form_data, {auth: false, msg_success: 'Veuillez cliquer dans le lien qui vient de vous être envoyé afin de valider votre nouveau mot de passe'});
		popup.hide();
	    }}
	]);
    }

    return getPopup.popup;
}
getPopup.popup = null;




